import { tw } from "@careinfo/tailwind";
import { CARD_DATA } from "./data";
import Graph from "./Graph";
import InvoiceCard from "./InvoiceCard";

export default ({ data, cardData }) => {
  const updatedCardData = CARD_DATA.map((card) => {
    let value;
    switch (card.title) {
      case "Sales Invoice":
        value = cardData.sales_total;
        break;
      case "Purchase Invoice":
        value = cardData.purchase_total;
        break;
      case "Profit and Loss":
        value = cardData.net_profit;
        break;
      case "Top Expenses":
        value = cardData.total_expense;
        break;
      default:
        value = 0;
    }
    return { ...card, value };
  });

  return (
    <div>
      <Graph data={data} />
      <div
        className={tw`my-4 grid grid-cols-2 gap-4 overflow-x-auto py-2 px-1`}
      >
        {updatedCardData.map((cd) => (
          <InvoiceCard
            key={cd.id}
            title={cd.title}
            time={cd.time}
            value={cd.value}
          />
        ))}
      </div>
    </div>
  );
};
